import { createActionGroup, props } from '@ngrx/store';

export const ScreenActions = createActionGroup({
  source: 'Screen',
  events: {
    '[Screen] Change': props<{ isMobile: boolean }>(),
  },
});
